const constant = {
    primaryColor: "#212A42",
    secondaryColor: "#609BEB",

    borderColor: "#333",
    blackColor: "#000",
    footerColor: "#496184",
    goldColor: "#FFD700",
};
export default constant; 